import React, { FC } from 'react'
import { useSignIn } from './useSignIn'

type SignInProps = {
  login?: string
  password?: string
  token?: string
  oauthCode?: string
}

type InputProps = {
  id: string
  name: string
  value: string
}

const SignIn: FC<SignInProps> = ({ login, password, token, oauthCode }) => {
  const { formRef, formAction, urlRedirect, oauthEmail } = useSignIn({
    login,
    password,
    token,
    oauthCode,
  })

  return (
    <form data-test-id='form-sign-in' ref={formRef} method='POST' action={formAction}>
      {(login || oauthEmail) && <Input name='email' id='oauthEmail' value={login || oauthEmail} />}
      {password && <Input name='senha' id='oauthSenha' value={password} />}
      {oauthCode && <Input name='code' id='oauthCode' value={oauthCode} />}
      <Input name='urlRedirect' id='urlRedirect' value={urlRedirect} />
    </form>
  )
}

const Input: FC<InputProps> = ({ id, name, value }) => (
  <input type='hidden' data-test-id={`input-${name}`} name={name} id={id} value={value} />
)

export default SignIn
